<script>

import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import CompanyAPI from "@/services/company/companyAPI";
import medicionFrecuenciaAPI from "@/services/standards/medicionFrecuencia/medicionFrecuenciaAPI"
import caracterizacionAccidentalidadAPI from "@/services/standards/caracterizacionAccidentalidad/caracterizacionAccidentalidadAPI"
import hazardIdentificationAPI from "@/services/standards/hazardIdentification/hazardIdentificationAPI";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import Swal from "sweetalert2";
import CheckModal from "@/components/CheckModal";
import { LineChart } from "chartist";

/**
 * Form elements component
 */
export default {
  page: {
    title: "Metodología para la identificación",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    CheckModal,
    Layout,
    Style,
    PageHeader,
  },
  data() {

    return {
      title: "Caracterización de la accidentalidad",

      years: [],
      show: [],

      listY: [],
      listM: [],
      excel: null,

      chartOptions: {
        lineSmooth: false,
      },

      chartData: {
        labels: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
        series: [
          [],
          [],
          [],
          [],
          [],
          [],
          /*   [], */

        ],
      },


      chartData2: {
        labels: [],
        series: [
          [],
          [],
          [],
          [],
          [],

          /*   [], */

        ],
      },

      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,

      meses: [
        {
          id: 1,
          name: "Enero"
        },
        {
          id: 2,
          name: "Febrero"
        },
        {
          id: 3,
          name: "Marzo"
        },
        {
          id: 4,
          name: "Abril"
        },
        {
          id: 5,
          name: "Mayo"
        },
        {
          id: 6,
          name: "Junio"
        },
        {
          id: 7,
          name: "Julio"
        },
        {
          id: 8,
          name: "Agosto"
        },
        {
          id: 9,
          name: "Septiembre"
        },
        {
          id: 10,
          name: "Octubre"
        },
        {
          id: 11,
          name: "Noviembre"
        },
        {
          id: 12,
          name: "Diciembre"
        },
      ],

      unoA: null,
      dosA: null,
      tresA: null,
      cuatroA: null,
      cincoA: null,
      seisA: null,
      sieteA: null,
      ochoA: null,
      nueveA: null,
      diezA: null,

      unoC: null,
      dosC: null,
      tresC: null,
      cuatroC: null,
      cincoC: null,
      seisC: null,
      sieteC: null,
      ochoC: null,
      nueveC: null,
      diezC: null,

      //-------//
      january_a: null,
      february_a: null,
      march_a: null,
      april_a: null,
      may_a: null,
      june_a: null,
      july_a: null,
      august_a: null,
      september_a: null,
      october_a: null,
      november_a: null,
      december_a: null,
      //-------//


      january_p: null,
      february_p: null,
      march_p: null,
      april_p: null,
      may_p: null,
      june_p: null,
      july_p: null,
      august_p: null,
      september_p: null,
      october_p: null,
      november_p: null,
      december_p: null,
      //-------//
      january_a: null,
      february_a: null,
      march_a: null,
      april_a: null,
      may_a: null,
      june_a: null,
      july_a: null,
      august_a: null,
      september_a: null,
      october_a: null,
      november_a: null,
      december_a: null,
      //-------//
      january_t: null,
      february_t: null,
      march_t: null,
      april_t: null,
      may_t: null,
      june_t: null,
      july_t: null,
      august_t: null,
      september_t: null,
      october_t: null,
      november_t: null,
      december_t: null,

      january_i: null,
      february_i: null,
      march_i: null,
      april_i: null,
      may_i: null,
      june_i: null,
      july_i: null,
      august_i: null,
      september_i: null,
      october_i: null,
      november_i: null,
      december_i: null,
      //-------//
      january_c: null,
      february_c: null,
      march_c: null,
      april_c: null,
      may_c: null,
      june_c: null,
      july_c: null,
      august_c: null,
      september_c: null,
      october_c: null,
      november_c: null,
      december_c: null,
      //-------//
      january_an: null,
      february_an: null,
      march_an: null,
      april_an: null,
      may_an: null,
      june_an: null,
      july_an: null,
      august_an: null,
      september_an: null,
      october_an: null,
      november_an: null,
      december_an: null,

      january_m: null,
      february_m: null,
      march_m: null,
      april_m: null,
      may_m: null,
      june_m: null,
      july_m: null,
      august_m: null,
      september_m: null,
      october_m: null,
      november_m: null,
      december_m: null,



      selected: null,

      medicionY: {
        year: null,
        companie_id: this.$store.getters["company/getCompany"].id || null,
      },

      medicionM: {
        initial_date: null,
        end_date: null,
      },

    };
  },
  methods: {


    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"].company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
   * This method is used to knows if the user has the permission indicated
   * @param {String} name The name of the permission
   * @param {Array} roles the roles that permitted to access the action 
   * @returns {Boolean} true if the user has the permission indicated or false if no
   */
    getRole(name, roles) {

      // Get the user role
      let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null

      // If the user is logged
      if (role) {

        // If the roles array is not empty
        if (roles) {

          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false

        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {

          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8

        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions

        // Know if the user has the permission indicated
        const enabled = permissions.find(permission => permission.name === name)

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false

      } // Close if the user is logged

      // If the user is not logged
      else {
        return false
      } // Close else the user is not logged
    },




    show(id) {
      medicionFrecuenciaAPI.show(id)
        .then((response) => {
          let medicion = response;
          this.show = medicion;
          console.log('show', this.show);

        })
        .catch((error) => {
          console.log(error);
        });
    },

    async todos() {
      this.getGrafica()
      this.saveY()
    },

    async todos2() {

      this.saveM()
    },

    getGrafica2() {

      medicionFrecuenciaAPI.saveYears(this.medicionM)
        .then((response) => {
          let medicion = response;
          this.listM = medicion;
          /*  this.chartData2 = this.listM */

          for (let i = 0; i <= this.listM.length; i++) {
            this.chartData2.labels.push(this.listM[i].Periodo)
            console.log(this.chartData2.labels);

            this.chartData2.series[0].push(this.listM[i].Indicador_Frecuencia)
            console.log(this.chartData2.series[0])

            this.chartData2.series[1].push(this.listM[i].Total_Colaboradores)
            console.log(this.chartData2.series[1])

            this.chartData2.series[2].push(this.listM[i].Accidentes_year)
            console.log(this.chartData2.series[2])
            /* 
                        this.chartData2.series[3].push(this.listM[i].annual_goal)
                        console.log(this.chartData2.series[3])
            
                        this.chartData2.series[4].push(this.listM[i].monthly_goal)
                        console.log(this.chartData2.series[4]) */
          }

        })
        .catch((error) => {
          console.log(error);
        });
    },
    

    saveM() {

      caracterizacionAccidentalidadAPI.getAll(this.companyID, this.medicionM)
        .then((response) => {
          let medicion = response.data.data;
          this.listM = medicion;
          console.log('listY', this.listM);

          if(response.data.data.length === 0) {
            Swal.fire({
                    title: "No hay accidentes registrados en el rango de fechas seleccionado",
                    type: "warning",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
          }

        })
        .catch((error) => {
          console.log(error);
        });
    },

    async print() {
      caracterizacionAccidentalidadAPI.getAll(this.companyID, this.medicionM)
        .then((response) => {
          if(response.data.data.length === 0) {
            Swal.fire({
                title: "No hay accidentes registrados en el rango de fechas seleccionado",
                type: "warning",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
          }else{
            try {
              const url =
                `https://sst-backend-xf8ho.ondigitalocean.app/api/characterization_accident_rate/${this.companyID}?&initial_date=${this.medicionM.initial_date}&end_date=${this.medicionM.end_date}`;
                console.log('acaaaaaaaaaaaaaaaaaaaaaa  URL',url);
                window.location.href = url;
            } catch (error) {
              console.log(error);
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    goBack() {
      this.$router.go(-1);
    },


    rangeYear() {
      const max = 2040
      const min = 2019
      /*       const years = [] */

      for (let i = min; i <= max; i++) {
        this.years.push(i)
      }
      return this.years,
        console.log(this.meses);
      console.log(this.years)


    },

    goPage(page) {
      window.location.href = page
    },


  },

  mounted() {
    this.rangeYear();
    /*   this.saveY() */
    this.getGrafica();
    this.todos();
    /*    this.todos2(); */
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12  m-0 p-0">
        <div class="card">
          <div class="card-body  ">

            <div class="row">
              <div class="col-12 text-right m-b-0">
                <div class="btn btn-secondary m-l-5 ml-1" id="back" @click="goBack">
                  <i class="fas fa-arrow-left"></i>
                </div>
                <b-tooltip target="back" placement="left"> Volver </b-tooltip>
              </div>
            </div>

            <hr>

            <form class="row pt-3 pl-2" @submit.prevent="todos2">

              <b-form-group class="col-md-2 px-3" label="Fecha inicial" label-for="trainingDate">
                <b-form-input type="date" id="trainingDate" v-model="medicionM.initial_date">
                </b-form-input>

              </b-form-group>

              <b-form-group class="col-md-2 px-3" label="Fecha final" label-for="trainingDate">
                <b-form-input type="date" id="trainingDate" v-model="medicionM.end_date">
                </b-form-input>

              </b-form-group>

              <div class="col-md-4 col-sm-12 mt-1">
                <button @click="awesome = !awesome" type="submit" name="boton" class="btn btn-primary mt-3">
                  Generar reporte
                </button>
              </div>

              <div class="col-md-4 col-sm-12 d-flex justify-content-end px-3">
                <button :disabled="this.listM.length === 0" @click=print type="submit" name="boton" class="btn btn-primary mt-3">
                  Descargar excel
                </button>
              </div>


              <div class="table-responsive px-3 pt-4">
                <table class="
                                                                      pt-2
                                                                      table
                                                                      border-bottom
                                                                      divide-y divide-gray-200
                                                                     table-bordered
                                                                      rounded
                                                                    ">
                  <thead class="bg-primary text-light">

                    <tr>

                      <th class="text-center align-middle">Mes del accidente</th>
                      <th class="text-center align-middle">Numero del documento del colaborador</th>
                      <th class="text-center align-middle">Nombre del colaborador</th>
                      <th class="text-center align-middle">Descripción del accidente</th>
                      <th class="text-center align-middle">Días de incapacidad por accidente de trabajo</th>

                    </tr>
                  </thead>
                  <tbody class="bg-white divide-y divide-gray-200">
                    <tr v-for="item in listM">
                      <td class=" bg-primary text-center text-white align-middle">
                        {{ item.mes_accidente }}
                      </td>
                      <td class="text-center align-middle">
                        {{ item.numero_documento_colaborador }}
                      </td>
                      <td class="text-center align-middle">
                        {{ item.nombre_colaborador }}
                      </td>
                      <td class="text-center align-middle">
                        {{ item.descripcion_accidente }}
                      </td>
                      <td class="text-center align-middle">
                        {{ item.dias_incapacidad_accidente_trabajo }}
                      </td>
                    </tr>

                  </tbody>
                </table>
                <!--       <div class="form-group text-right m-b-0  mt-3">
                                          <button @click="" type="submit" name="boton" class="btn btn-primary">
                                            Generar
                                          </button>
                                          <button type="button" class="btn btn-secondary mx-1">
                                            Cancelar
                                          </button>
                                        </div> -->
              </div>

              <!--            <div v-if="awesome" class="col-lg-12 pt-3">
                        <div class="card">
                          <div class="card-body" dir="ltr">
                            <h4 class="header-title">Grafica</h4>
                            <ul>
                              <li style="color:#00707f">Frecuencia de accidentalidad</li>
                              <li style="color:#f7b84b">Total de accidentes de trabajo anuales</li>
                              <li style="color:#1abc9c">Número de trabajadores</li>
                            </ul>
                            <p class="sub-header"></p>

                            <Chartist ratio="ct-chart" :data="chartData2" :options="chartOptions" type="Line"></Chartist>
                          </div>
                        </div>
                      </div> -->
            </form>

            <!--          <div class="row pt-3" v-if="selected === 1">
                                          <div class="col-md-3 col-sm-12">
                                            <h5>Meta mensual: {{ this.listM.monthly_goal }}</h5>
                                          </div>
                                          <div class="col-md-3 col-sm-12">
                                            <h5>Meta anual: {{ this.listM.annual_goal }}</h5>
                                          </div>
                                          <div class="col-md-6 col-sm-12">

                                          </div>
                                        </div> -->

            <!--      <div class="row pt-3" v-if="selected === 2">
                                            <div class="col-md-3 col-sm-12">
                                              <h5>Meta mensual: {{ this.listY.monthly_goal }}</h5>
                                            </div>
                                            <div class="col-md-3 col-sm-12">
                                              <h5>Meta anual: {{ this.listY.annual_goal }}</h5>
                                            </div>
                                            <div class="col-md-6 col-sm-12">

                                            </div>
                                          </div> -->


            <br />

            <!--             <form class="form-group" v-if="selected === 2" @submit.prevent="save">

                                              <div class="table-responsive" v-if="getRole('Consultar')">
                                                <table class="
                                                                                    pt-2
                                                                                    table
                                                                                    border-bottom
                                                                                    divide-y divide-gray-200
                                                                                   table-bordered
                                                                                    rounded
                                                                                  ">
                                                  <thead class="bg-primary text-light">

                                                    <tr>

                                                      <th class="text-center align-middle">Periodo</th>
                                                      <th class="text-center align-middle">Número de trabajadores</th>
                                                      <th class="text-center align-middle">Total de accidentes de trabajo mensuales</th>
                                                      <th class="text-center align-middle">Frecuencia de accidentalidad </th>
                                                      <th class="text-center align-middle">Cumple</th>

                                                    </tr>
                                                  </thead>
                                                  <tbody class="bg-white divide-y divide-gray-200">
                                                    <tr v-for="item in listY">
                                                      <td class="bg-primary text-center text-white align-middle">
                                                        {{ item.Periodo }}
                                                      </td>
                                                      <td class="text-center align-middle">
                                                        {{ item.Total_Colaboradores }}
                                                      </td>
                                                      <td class="text-center align-middle">
                                                        {{ item.Accidentes_Mensuales }}
                                                      </td>
                                                      <td class="text-center align-middle">
                                                        {{ item.Indicador_Frecuencia }}
                                                      </td>
                                                      <td class="text-center align-middle">
                                                        {{ item.Cumple }}
                                                      </td>
                                                    </tr>

                                                  </tbody>
                                                </table>
                                                <div class="form-group text-right m-b-0  mt-3">
                                                  <button @click="" type="submit" name="boton" class="btn btn-primary">
                                                    Generar
                                                  </button>
                                                  <button type="button" class="btn btn-secondary mx-1">
                                                    Cancelar
                                                  </button>
                                                </div>
                                              </div>




                                            </form> -->

            <!--           <form class="form-group" v-if="selected === 1" @submit.prevent="save">

                                          <div class="table-responsive" v-if="getRole('Consultar')">
                                            <table class="
                                                                      pt-2
                                                                      table
                                                                      border-bottom
                                                                      divide-y divide-gray-200
                                                                     table-bordered
                                                                      rounded
                                                                    ">
                                              <thead class="bg-primary text-light">

                                                <tr>

                                                  <th class="text-center align-middle">Periodo</th>
                                                  <th class="text-center align-middle">Número de trabajadores</th>
                                                  <th class="text-center align-middle">Total de accidentes de trabajo mensuales</th>
                                                  <th class="text-center align-middle">Frecuencia de accidentalidad </th>
                                                  <th class="text-center align-middle">Cumple</th>

                                                </tr>
                                              </thead>
                                              <tbody class="bg-white divide-y divide-gray-200">
                                                <tr>
                                                  <td class=" bg-primary text-center text-white align-middle">
                                                    {{ this.listM.Periodo }}
                                                  </td>
                                                  <td class="text-center align-middle">
                                                    {{ this.listM.Total_Colaboradores }}
                                                  </td>
                                                  <td class=" text-center align-middle">
                                                    {{ this.listM.Accidentes_Mensuales }}
                                                  </td>
                                                  <td class="text-center align-middle">
                                                    {{ this.listM.Indicador_Frecuencia }}
                                                  </td>
                                                  <td class="text-center align-middle">
                                                    {{ this.listM.Cumple }}
                                                  </td>
                                                </tr>

                                              </tbody>
                                            </table>
                                            <div class="form-group text-right m-b-0  mt-3">
                                              <button @click="" type="submit" name="boton" class="btn btn-primary">
                                                Generar
                                              </button>
                                              <button type="button" class="btn btn-secondary mx-1">
                                                Cancelar
                                              </button>
                                            </div>
                                          </div>




                                        </form> -->


          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>